import { makeBulkTreatmentsEarlyRequest } from './bulk-experiments-request/makeBulkTreatmentsEarlyRequest';
makeBulkTreatmentsEarlyRequest();